import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../../../../../../../../components/Common/UI/Dialog';
import { cn } from '../../../../../../../../utils/styles';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import Separator from '../../../../../../../../components/Common/UI/Separator';
import { IModalProps } from '../../Select';

interface IDeleteUser extends IModalProps {
  handleDeleteUser: () => void;
}

function ModalDeleteUser({ open, handleOpen, handleDeleteUser }: IDeleteUser) {
  return (
    <Dialog open={open} onOpenChange={e => handleOpen(e, 'delete')}>
      <DialogContent className={cn('max-h-[98%] max-w-[690px]')}>
        <DialogTitle className="mb-[10px] font-normal text-[16px]">
          <div className="font-bold text-xl leading-[24px]">Delete User</div>
        </DialogTitle>
        <div>
          <div className="text-primary-60">Are you sure you want to delete user?</div>
          <div className="text-primary-60">
            For this User Name:
            <strong className="mx-[5px]">demonewusr test_usr_12345</strong>
            from this
          </div>
          <div className="text-primary-60">
            Account:
            <strong className="ml-[5px]">1234567</strong>
          </div>
          <div className="text-primary-60">This action cannot be undone.</div>
        </div>
        <Separator className="m-0" />
        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => handleOpen(false, 'delete')}>
            Cancel
          </Button>
          <Button
            variant="default"
            className="py-3 !bg-addition5 hover:opacity-85 px-[20px]"
            onClick={() => {
              handleDeleteUser();
              handleOpen(false, 'delete');
            }}
          >
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalDeleteUser;
